export default __webpack_public_path__ + "static/GreenScreen-64b3fc376d1b9333c4896aa954bd08fc.png";